<template>
<div class="inner-content m-t-xl b-gray-1 p-y-30 text-center" style="margin-bottom: 60px;">
  <div class="wx-qr-wrp">
    <div class="pay-title">
      <div class="pull-right">应付金额：<span class="text-price">{{weixinOrder.price / 100 || 0}}</span>元</div>
      微信支付
    </div>
    <div style="margin: 20px 0;" class="b-gray-1">
      <img style="height: 298px; width: 298px;" :src="imgSrc" />
    </div>
    <div class="wx-pay-desc text-center">
      <img src="../assets/scan-code.png">
      <div class="d-i">
        请使用微信扫一扫 <br>
        扫描二维码支付
      </div>
    </div>
  </div>
  <img style="margin-top: 25px;" src="../assets/iphone-bj.png">
</div>
</template>
<script>
  /* eslint-disable */
import QRious from 'qrious';
import service from '../service/apiHelper';

export default {
  name: 'WeixinPay',
  created() {
    this.weixinOrder = JSON.parse(localStorage.getItem('WEIXIN_ORDER_INFO'));
    const charge = JSON.parse(this.weixinOrder.orderPay.extraPayInfo);
    console.log('weixinOrder:'+ localStorage.getItem('WEIXIN_ORDER_INFO'));
    this.wxqr = charge.credential.wx_pub_qr;
    this.timeWait = 60;
    const qr = new QRious({
      value: this.wxqr,
    });
    this.imgSrc = qr.toDataURL('image/jpeg');
    this.watchOrderStatus(this.weixinOrder.id);
  },
  data() {
    return {
      weixinOrder: undefined,
      orderInfo: {},
      timeWait: 0,
      wxqr: undefined,
      imgSrc: undefined,
      interValEvent: undefined,
      timer: false,
    };
  },
  methods: {
    watchOrderStatus(id) {
      service.getOrderDetail(id).then((resp) => {
        if(this.timer) {
          return;
        }
        this.orderInfo = resp.data.order_info;
        if (this.orderInfo.status === 1) {
          this.$router.push({ name: 'PaySuccess', params: { id } });
          this.timer = true;
        }
        setTimeout(this.watchOrderStatus(id), 3000);
      });
    },
  },
};

</script>
<style>
.wx-qr-wrp {
  display: inline-block;
  width: 300px;
  margin-right: 100px;
  vertical-align: top;
}
.pay-title {
  text-align: left;
  font-size: 20px;
}
.wx-pay-desc {
  background-color: #ba882a;
  font-size: 14px;
  font-weight: 600;
  color: #f3f3f3;
  padding: 9px 0;
}
.wx-pay-desc > * {
  display: inline-block;
  vertical-align: middle;
}
.d-i {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// WeixinPay.vue?6904f062